import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { SuggestionsTrigger } from '@pflegia/types/common/enums';
import { APPLICATIONS, CHAT_ROOT, JOB, JOB_BOARD } from '@pflegia/ui/pflegia/constants/routes';

import { ExitIntentBlocker } from '../../ExitIntentBlocker';
import { useSuggestionModalLogic } from '../hooks/use-suggestion-modal-logic';

const SuggestionsModal = dynamic(() => import('./Modal'), { ssr: false });

type Props = { condition?: boolean; enableOnExit: boolean | 'auto'; trigger?: SuggestionsTrigger; ignoredRoutes?: string[] };

const WrappedSuggestionsModal = ({ condition, enableOnExit, trigger: forcedTrigger, ignoredRoutes }: Props) => {
  const { store, handleOpen: handleOpenSuggestionsModal } = useSuggestionModalLogic();
  const { open: suggestionsModalVisible, trigger: storeTrigger } = store;

  const { pathname } = useRouter();

  const shouldEnableOnExit = useMemo(
    () =>
      enableOnExit ||
      // @ts-expect-error enableOnExit can be 'auto'
      (enableOnExit === 'auto' &&
        //
        [CHAT_ROOT, JOB_BOARD, JOB, APPLICATIONS].some(path => pathname.startsWith(path))),
    [enableOnExit, pathname],
  );

  return shouldEnableOnExit ? (
    <ExitIntentBlocker
      condition={condition}
      ignoredRoutes={ignoredRoutes}
      onTrigger={initialNavigation => {
        handleOpenSuggestionsModal(
          {
            initialNavigation,
            trigger: forcedTrigger ?? storeTrigger,
          },
          true,
        );
      }}>
      {() => suggestionsModalVisible && <SuggestionsModal />}
    </ExitIntentBlocker>
  ) : (
    suggestionsModalVisible && <SuggestionsModal />
  );
};
export default WrappedSuggestionsModal;
